<template>
	<div>
		<form @submit.prevent="search">
			<div class="search-input-complex ">
				<div class="autocomplete">
					<div class="input-box">
						<!-- <b-form-select 
                        v-if="!loading"
                        v-model="selectedCategory"  >
                        <template #first>
                            <b-form-select-option :value="null" disabled>Seleccione un tipo de exámen</b-form-select-option>
                        </template>
                        <b-form-select-option v-for="category in services" :key="category.id" :value="category.slug">{{category.name}}</b-form-select-option>
                    </b-form-select>
                    
                    <b-form-select 
                        v-if="!loading"
                        v-model="selectedService">
                        <template #first>
                            <b-form-select-option :value="null" disabled>Seleccione un exámen</b-form-select-option>
                        </template>
                        <b-form-select-option v-for="service in clinicServices" :key="service.id" :value="service.slug">{{service.name}}</b-form-select-option>
                    </b-form-select> -->

						<input
							type="text"
							class="form-control"
							ref="searchInput"
							placeholder="Exámen, clínica o tratamiento"
							v-model="searchInput.name"
							@focus="
								suggestOpen = 'search'
								error = false
							"
						/>
						<div class="loading" v-if="searching">
							<i class="icon_loading animate-spin"></i>
						</div>
					</div>

					<div class="results-box" v-if="!searching && suggestOpen == 'search' && (clinics.length > 0 || services.length > 0)">
						<div class="group" v-if="services.length > 0">
							<div class="group-name">
								Exámenes
							</div>
							<div class="group-results">
								<div class="simple-result" v-for="item in services" :key="item.id" @click="selectOption(item, 'service')">
									<!-- <span class="text-secondary">{{item.clinic_services.name}}</span> -->
									{{ item.name }}
								</div>
							</div>
						</div>

						<div class="group" v-if="clinics.length > 0">
							<div class="group-name">
								Clínicas
							</div>
							<div class="group-results">
								<div class="profile-result" v-for="clinic in clinics" :key="clinic.id" @click="selectOption(clinic, 'clinic')">
									<div class="profile-picture">
										<div
											class="image"
											v-if="clinic.picture"
											:style="'background-image:url(' + API_URL + clinic.picture.urlThumb + ')'"
										></div>
										<div
											class="avatar"
											v-else
											:style="'background-image:url(' + require('@/assets/img/no-avatar-image-thumb.gif') + ')'"
										></div>
									</div>
									<div class="profile-data">
										<div class="title">
											{{ clinic.name }}
										</div>
										<div class="subtitle" v-if="clinic.addresses.length == 1">
											<span v-if="clinic.addresses[0]"
												>{{ clinic.addresses[0].locality.name }},
												{{ clinic.addresses[0].locality.region.name }}
											</span>
										</div>
										<div class="subtitle" v-if="clinic.addresses.length > 1">
											Multiples direcciones
										</div>
									</div>
								</div>
								<div class="simple-result" v-if="searchInput.length > 0" @click="selectOption(searchInput, 'service')">
									<hr />
									Buscar todas las clínicas llamadas
									<span class="highlight">"{{ searchInput }}"</span>
								</div>
							</div>
						</div>
					</div>
				</div>

				<input type="submit" class="btn_search" value="Buscar" />

				<div class="animated text-left fadeInUp faster error" v-if="error">
					La búsqueda no es correcta.<br />
					Te sugerimos ingresar las primeras letras del analisis o clínica, para recibir la sugerencia
				</div>
			</div>
			<router-link class="link" tag="a" to="/exams">Ver todos los exámenes</router-link>
		</form>
	</div>
</template>

<script>
import gql from 'graphql-tag'

export default {
	name: 'SearchBar',
	props: {
		service: {
			type: Object,
			default() {
				return {
					name: '',
					slug: '',
				}
			},
		},
		region: {
			type: Object,
			default() {
				return {
					name: '',
					slug: '',
				}
			},
		},
	},
	computed: {
		clinicServices: function() {
			if (this.selectedCategory) {
				const service = this.services.filter((service) => service.slug == this.selectedCategory)
				return service[0].clinic_services
			}
			return []
		},
	},
	watch: {
		service: function(newVal) {
			this.searchInput = newVal
		},
		// region: function (newVal) {
		//     this.searchRegionsInput = newVal;
		// }
	},

	data() {
		return {
			showLocationInput: false,
			searchInput: this.service,
			searchRegionsInput: this.region,
			services: [],
			clinics: [],
			regions: {
				data: [],
			},
			suggestOpen: false,
			API_URL: process.env.VUE_APP_API_URL,
			error: false,
			loading: false,
			searching: false,
			selectedCategory: null,
			selectedService: null,
		}
	},

	async beforeMount() {
		this.loading = true
		// await this.load()
		this.loading = false
	},

	methods: {
		startSuggest() {
			console.log('startSuggest')
			this.$apollo.queries.clinics.skip = false
			this.$apollo.queries.clinics.refetch()
			this.searchInput.slug = ''
		},

		selectOption(selected, type) {
			console.log('selectOption')
			if (type == 'service') {
				this.searchInput = selected
				// this.suggestOpen='location';
				// if(!this.showLocationInput){
				this.startSearch()
				// }
			}
			if (type == 'clinic') {
				let destinationUrl = `/clinic/${selected.id}-${selected.slug}`
				this.$router.push(destinationUrl)
			}
		},

		load() {
			return this.$apollo
				.query({
					query: gql`
						query search($count: Int!) {
							clinic_service_categories(count: $count) {
								data {
									id
									name
									slug
									clinic_services {
										id
										slug
										name
									}
								}
							}
						}
					`,
					variables: {
						count: 1000,
					},
				})
				.then(({ data }) => {
					this.services = data.clinic_service_categories.data

					// reviso si hay algun servicio pre seleccionado.
					this.services.map((service) => {
						service.clinic_services.map((clinic_service) => {
							if (clinic_service.id == this.service.id) {
								console.log(service)
								this.selectedCategory = service.slug
								this.selectedService = clinic_service.slug
							}
						})
					})

					return data.clinic_service_categories.data
				})
				.catch((error) => {
					console.log('error al buscar.', error)
				})
		},

		search() {
			// reviso si tengo escrito algo.
			if (this.selectedService && !this.searchInput.name) {
				//redirecciono directamente.
				let destinationUrl = `/clinics/${this.selectedService}`
				// this.$router.push(destinationUrl)
				// this.$forceUpdate()
				window.location = destinationUrl
			} else {
				this.searching = true
				this.error = false
				this.suggestOpen = false
				this.$apollo
					.query({
						query: gql`
							query search($count: Int!, $search: String, $service: String) {
								clinicCenters(count: $count, search: $search, service: $service) {
									data {
										id
										name
										slug
										status
										picture {
											urlThumb
										}
										services {
											service {
												name
												category {
													name
												}
											}
										}
										addresses {
											locality {
												name
												region {
													name
												}
											}
										}
									}
								}

								clinic_services(count: $count, search: $search) {
									data {
										id
										name
										slug
									}
								}
							}
						`,
						variables: {
							count: 20,
							search: this.searchInput.name,
							service: this.selectedService,
						},
						fetchPolicy: 'no-cache',
					})
					.then((data) => {
						this.services = data.data.clinic_services.data

						this.clinics = data.data.clinicCenters.data
						this.searching = false

						if (this.services.length > 0 || this.clinics.length > 0) {
							// if( this.clinics.length>0 ){
							this.error = false
							this.suggestOpen = 'search'
						} else {
							this.error = true
							this.suggestOpen = false
						}
					})
					.catch((error) => {
						console.log('error al buscar.', error)
					})
			}
		},

		startSearch() {
			if (!this.searching) {
				if (this.searchInput && this.searchInput.slug != '') {
					let destinationUrl = '/clinics/' + this.searchInput.slug
					// if( this.showLocationInput && this.searchRegionsInput.name !=' '   ){
					//     destinationUrl += '/' + this.searchRegionsInput.slug;
					// }
					this.$router.push(destinationUrl)
				} else {
					this.error = true
					this.suggestOpen = false
				}
			} else {
				this.error = true
				this.suggestOpen = false
			}
		},
	},
}
</script>

<style scoped>
.link {
	text-transform: uppercase;
	font-size: 12px;
	margin: 0px;
	color: #000;
}
.search-input-complex {
	top: 0;
	padding: 0;
	max-width: 650px;
	margin: auto;
	position: relative;
	display: flex;
}

.search-input-complex .autocomplete {
	position: relative;
	text-align: left;
	text-shadow: none;
	color: #333;
	width: 100%;
}
.search-input-complex .autocomplete:first-child {
	flex-grow: 2;
	border-right: 1px solid #e4e4e4;
}
.autocomplete .input-box {
	width: 100%;
	flex-grow: 1;
	display: inline-flex;
	background-color: #fff;
	align-items: center;
}
.autocomplete .input-box .custom-select {
	border: none;
	background-color: #f3f3f3;
	margin-left: 4px;
	font-size: 13px;
}

.autocomplete .input-box .loading {
	position: absolute;
	right: 0px;
	top: 0px;
	bottom: 0px;
	display: flex;
	align-items: center;
	padding: 8px;
}

.autocomplete .input-box .loading i {
	font-size: 16px;
	color: #999;
}
.autocomplete .results-box {
	width: 100%;
	min-width: 400px;
	position: absolute;
	top: 58px;
	background-color: #fff;
	z-index: 10;
	box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.35);
}
.search-input-complex .autocomplete:first-child .form-control {
	border-radius: 3px 0px 0px 3px;
}
.autocomplete .results-box:before {
	content: '';
	width: 0;
	height: 0;
	border-style: solid;
	border-width: 0 10px 10px 10px;
	border-color: transparent transparent #fafafa transparent;
	position: absolute;
	top: -6px;
	left: 17px;
}

.autocomplete .results-box .group {
	display: flex;
	border-bottom: solid 1px #ccc;
	overflow: hidden;
}
.autocomplete .results-box .group:first-child {
	border-radius: 3px 3px 0px 0px;
}
.autocomplete .results-box .group:last-child {
	border-radius: 0px 0px 3px 3px;
	border-bottom: none;
}

.autocomplete .results-box .group .group-name {
	font-size: 12px;
	background-color: #fafafa;
	color: #000;
	font-weight: 600;
	padding: 8px;
	width: 110px;
	flex-grow: 0;
	flex-shrink: 0;
}

.search-input-complex .error {
	background-color: #ffec70;
	padding: 8px;
	border-radius: 2px;
	position: absolute;
	top: 52px;
	font-size: 0.8rem;
}

.group-results {
	flex-grow: 1;
}
.group-results .simple-result {
	font-size: 14px;
	padding: 8px 12px;
	width: 100%;
	cursor: pointer;
}
.group-results .simple-result:hover {
	background-color: #f5f5f5;
}
.group-results .profile-result {
	font-size: 14px;
	padding: 8px 12px;
	width: 100%;
	display: flex;
	cursor: pointer;
}
.group-results .profile-result:hover {
	background-color: #f5f5f5;
}
.group-results .profile-result .profile-picture {
	width: 34px;
	height: 34px;
	margin-right: 10px;
	flex-grow: 0;
	flex-shrink: 0;
	border-radius: 50%;
	border: solid 1px #ccc;
	overflow: hidden;
}
.group-results .profile-result .profile-picture .image {
	width: 34px;
	height: 34px;
	background-size: cover;
	background-position: center center;
}
.group-results .profile-result .profile-data {
	flex-grow: 0;
	font-size: 14px;
	padding: 3px 6px;
	width: 100%;
}
.group-results .profile-result .profile-data .title {
}
.group-results .profile-result .profile-data .subtitle {
	color: #999;
}
hr {
	margin: none;
}

.form-control {
	width: 100%;
	height: 50px;
	padding-left: 20px;
	border: 0;

	/* -webkit-box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.35);
    -moz-box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.35);
    box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.35); */
	font-weight: 500;
	font-size: 16px;
	font-size: 1rem;
	color: #333;
	border-radius: 0px;
}

.form-control:focus {
	outline: none;
}

@media (max-width: 575px) {
	.form-control {
		/* For less than 575px */
		padding-left: 15px;
	}
}

#custom-search-input ul {
	text-align: center;
	margin-top: 25px;
}

#custom-search-input ul li {
	display: inline-block;
	margin-right: 5px;
	font-size: 13px;
	font-size: 0.8125rem;
	font-weight: 600;
}

#custom-search-input ul li input[type='radio'] {
	display: none;
}

#custom-search-input ul li input[type='radio']:checked + label,
#custom-search-input ul li input[type='radio']:checked + label:hover {
	background-color: #12bcec;
	color: #fff;
}

#custom-search-input ul li input[type='radio']:hover + label {
	background-color: #e74e84;
	color: #fff;
}

#custom-search-input ul li label {
	display: inline-block;
	-moz-transition: all 0.3s ease-in-out;
	-o-transition: all 0.3s ease-in-out;
	-webkit-transition: all 0.3s ease-in-out;
	-ms-transition: all 0.3s ease-in-out;
	transition: all 0.3s ease-in-out;
	background-color: black;
	background-color: rgba(0, 0, 0, 0.3);
	-webkit-border-radius: 3px;
	-moz-border-radius: 3px;
	-ms-border-radius: 3px;
	border-radius: 3px;
	padding: 8px 10px 6px 10px;
	line-height: 1;
	text-shadow: none;
	min-width: 80px;
	text-align: center;
	cursor: pointer;
}

#custom-search-input ul li:last-child {
	margin-right: 0;
}

.btn_search[type='submit'] {
	-moz-transition: all 0.3s ease-in-out;
	-o-transition: all 0.3s ease-in-out;
	-webkit-transition: all 0.3s ease-in-out;
	-ms-transition: all 0.3s ease-in-out;
	transition: all 0.3s ease-in-out;
	right: 0;
	color: #fff;
	font-weight: 600;
	font-size: 16px;
	font-size: 1rem;
	top: 0;
	border: 0;
	padding: 0 25px;
	height: 50px;
	cursor: pointer;
	outline: none;
	-webkit-border-radius: 0 3px 3px 0;
	-moz-border-radius: 0 3px 3px 0;
	-ms-border-radius: 0 3px 3px 0;
	border-radius: 0 3px 3px 0;
	background-color: #12bcec;
}

.btn_search[type='submit']:hover {
	background-color: #14657b;
}

@media (max-width: 575px) {
	.btn_search[type='submit'] {
		/* For less than 575px */
		text-indent: -999px;
		background: #12bcec url(../assets/img/search.svg) no-repeat center center;
	}
}
</style>
